/** Statuts dossier patient persistés (colonnes `patients.status`). */
export const PATIENT_STATUS_ACTIVE = 'active';
export const PATIENT_STATUS_INACTIVE = 'inactive';

/** Valeur normalisée pour comparaisons (minuscules, sans espaces). */
export function normalizePatientStatusValue(status) {
  if (status == null || status === '') return '';
  return String(status).trim().toLowerCase();
}

/**
 * Statuts considérés comme « inactifs » côté métier (tolère variantes en base / enum).
 */
export function isPatientMarkedInactiveStatus(status) {
  const n = normalizePatientStatusValue(status);
  if (n === '') return false;
  return (
    n === PATIENT_STATUS_INACTIVE ||
    n === 'inactif' ||
    n === 'disabled' ||
    n === 'false' ||
    n === '0'
  );
}

/**
 * Création de conception autorisée : tout sauf statuts explicitement inactifs
 * (absence de statut = rétrocompat., traité comme éligible).
 */
export function patientAllowsNewCase(patient) {
  if (!patient) return false;
  const raw =
    patient.status ??
    patient.statusRaw ??
    patient.status_raw ??
    patient.patientStatus;
  if (raw == null || String(raw).trim() === '') return true;
  return !isPatientMarkedInactiveStatus(raw);
}

/** Valeur affichée / éditable dans les formulaires : actif ou inactif uniquement. */
export function normalizePatientStatusForForm(status) {
  if (status == null || status === '') return PATIENT_STATUS_ACTIVE;
  return isPatientMarkedInactiveStatus(status)
    ? PATIENT_STATUS_INACTIVE
    : PATIENT_STATUS_ACTIVE;
}

export function patientStatusLabel(status) {
  return isPatientMarkedInactiveStatus(status) ? 'Inactif' : 'Actif';
}
